import { DEFAULT_PAGE_SIZE } from '@app/constants/Common';
import { requestCandidates } from '@app/services/CandidateService';
import SearchConditionInputNewModal from '@pages/candidate/list/SearchConditionInputNewModal';
import AdvanceSearchPipelineModal from '@pages/dvtjcuv/list/advancesearch/AdvanceSearchPipelineModal';
import SearchPipelineRangeModal from '@pages/dvtjcuv/list/advancesearch/SearchPipelineRangeModal';
import { requestGetDVTJCUVPipeLineList } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import React, { useState } from 'react';
import QuickSearchCandidateInput from "@pages/candidate/list/SearchCandidateInput";

const InitSearchConditions = {
    'search_by_cdd_list': {},
    'search_by_dvtjcuv_pipeline': {},
    'search_by_range': {},
}

const SearchCddConditionInput = (props) => {
    const [searchCddCondition, setSearchCddCondition] = useState({});
    const [quickSearchConditions, setQuickSearchConditions] = useState({});
    const [searchDVTJCUVPipelineCondition, setSearchDVTJCUVPipelineCondition] = useState({});

    const [isLoading, setLoading] = useState(false);
    const [hasSearchCdd, setHasSearchCdd] = useState(false);

    const [showSearchCddConditionModal, setShowSearchCddConditionModal] = useState(false);
    const [showSearchDVTJCUVPipelineConditionModal, setShowSearchDVTJCUVPipelineConditionModal] = useState(false);
    const [showSearchPipelineRangeConditionModal, setShowSearchPipelineRangeConditionModal] = useState(false);

    const [searchCddCandidateIds, setSearchCddCandidateIds] = useState([]);

    const {
        parentTabId,
        tabId,
        mode,
        pipelineIds,
        noPaging,
        notShowBtnSearchByCandidates,
        notShowBtnSearchByPipelines,
        notShowBtnSearchByRanges,
        btnSearchByPipelineText,
        onSearching,
        onSearchPipelineResult,
        onSearchCddRecResult,
    } = props

    const searchPipeLines = async (conditions, candidateIds, searchCdd) => {
        setSearchDVTJCUVPipelineCondition(conditions);
        const params = {
            search_conditions: conditions
        }

        if (searchCdd) {
            params.search_conditions.cdd_ids = candidateIds
            params.search_conditions.has_search_by_cdd_ids = true
        }

        if (parentTabId) {
            params.search_conditions.parent_tab = parentTabId
        }

        if (mode) {
            params.search_conditions.search_mode = mode
            if (mode === 'search-employer') {
                params.search_conditions.is_search_by_employer = true;
            }
        }

        if (tabId) {
            params.search_conditions.sub_tab = tabId
        }

        if (pipelineIds) {
            params.search_conditions.pipelineIds = pipelineIds
        }

        params.search_conditions.unlimited = true;

        setShowSearchDVTJCUVPipelineConditionModal(false)
        setShowSearchPipelineRangeConditionModal(false)
        setLoading(true)
        if (onSearching) {
            onSearching();
        }

        const res = await requestGetDVTJCUVPipeLineList(params);

        setLoading(false)
        const resContent = res.content
        const items = resContent.pipelines.map((item, index) => {
            if (noPaging) {
                item.no = index + 1
            } else {
                item.no = (resContent.page - 1) * DEFAULT_PAGE_SIZE + index + 1
            }
            return item
        });
        if (onSearchPipelineResult) {
            onSearchPipelineResult(items, resContent.totalCount);
        }
    }

    const fetchCandidateList = async (conditions, isQuickSearch = false) => {
        setHasSearchCdd(true)
        setSearchCddCondition(conditions);
        const params = {
            search_conditions: conditions
        }

        if (!conditions) {
            conditions = {}
        }

        params.search_conditions = {...searchCddCondition, ...conditions, ...quickSearchConditions}
        setSearchCddCondition(params.search_conditions)

        if (mode) {
            params.search_conditions.search_mode = mode
        }

        if (parentTabId) {
            params.search_conditions.parent_tab = parentTabId
        }

        if (tabId) {
            params.search_conditions.sub_tab = tabId
        }

        params.search_conditions.unlimited = true;
        if (onSearching) {
            onSearching();
        }

        // Trường hợp quicksearch
        //  thì bỏ lọc theo parent_tab và sub_tab (sửa tạm thời vì xử lý lọc theo parent_tab đang bị sai ở phía BE) và khi search pipeline có lọc theo tab rồi.
        // if (isQuickSearch) {
        //     params.search_conditions.parent_tab = '';
        // }
        
        const res = await requestCandidates(params);
        setSearchCddCandidateIds(res.content.all_candidate_ids);

        if (!notShowBtnSearchByPipelines || !notShowBtnSearchByRanges) {
            // Trường hợp có search cdd trước rồi mới search pipeline
            await searchPipeLines(searchDVTJCUVPipelineCondition, res.content.all_candidate_ids, true)
        } else {
            // Trường hợp chỉ có search theo kho person
            setLoading(false)
            onSearchCddRecResult(res.content.candidates, res.content.totalCount);
        }
    }

    return (
        <>
            <div className="row float-right mb-3">
                {!notShowBtnSearchByCandidates &&
                <div className="mr-3">
                    <button
                        onClick={() => setShowSearchCddConditionModal(true)}
                        type={"button"}
                        className={'btn btn-default btn-sm'}>
                        Search theo kho Person
                    </button>
                </div>
                }
                {!notShowBtnSearchByPipelines &&
                <div className="mr-3">
                    <button
                        onClick={() => setShowSearchDVTJCUVPipelineConditionModal(true)}
                        type={"button"}
                        className={'btn btn-default btn-sm'}>
                        {btnSearchByPipelineText || 'Search theo DVTJCUV Pipeline' }
                    </button>
                </div>
                }
                {!notShowBtnSearchByRanges &&
                <div className="mr-3">
                    <button
                        onClick={() => setShowSearchPipelineRangeConditionModal(true)}
                        type={"button"}
                        className={'btn btn-default btn-sm'}>
                        Search theo khoảng
                    </button>
                </div>
                }
            </div>
            <div style={{position: 'relative'}} className='mt-5'>
                {(mode === 'search-receiver' || mode === 'search-cdd') &&
                <QuickSearchCandidateInput
                                searchTitle={'Search nhanh'}
                                onChangeQuickSearch={(condition) => {
                                    console.log("onChangeQuickSearch condition: ", condition)
                                    setQuickSearchConditions(condition)
                                }}
                                onSearch={(condition) => fetchCandidateList(condition, true)}/>
                }

                <SearchConditionInputNewModal isShow={showSearchCddConditionModal}
                                        onSearch={(searchInput) => fetchCandidateList(searchInput)}
                                        onClose={() => setShowSearchCddConditionModal(false)}/>

                {/*<SearchConditionInputModal isShow={showSearchCddConditionModal}*/}
                {/*                                       onSearch={(searchInput) => fetchCandidateList(searchInput)}*/}
                {/*                                       onClose={() => setShowSearchCddConditionModal(false)} />*/}

                <AdvanceSearchPipelineModal
                    isShow={showSearchDVTJCUVPipelineConditionModal}
                    onClose={() => setShowSearchDVTJCUVPipelineConditionModal(false)}
                    showFullSearch
                    searchInput={searchDVTJCUVPipelineCondition}
                    onSearch={(conditions) => searchPipeLines(conditions, searchCddCandidateIds, hasSearchCdd)}/>

                <SearchPipelineRangeModal
                    mode={mode}
                    isShow={showSearchPipelineRangeConditionModal}
                    onClose={() => setShowSearchPipelineRangeConditionModal(false)}
                    searchInput={searchDVTJCUVPipelineCondition}
                    onSearch={(conditions) => searchPipeLines(conditions, searchCddCandidateIds, hasSearchCdd)}/>
            </div>
        </>
    )
}

export default SearchCddConditionInput;
